import { AET, baseURL, PACS_URL , LOCAL_PACS_URL,aiBaseURL} from "@custom/constant"
import { _config } from "../config/config"
import { DCMurlParamsType } from "./interfaces"
const appPath = (route) => `${baseURL}${route}`
const dcemPath=(route)=>`${PACS_URL}${route}`
const localDcemPath=(route)=>`${LOCAL_PACS_URL}${route}`
const codingSchemeDesignator = 'DCM'
const aiPath = (route) => `${aiBaseURL}${route}`

// Define Your Api's End Points
export const _authUrls = {
  login: appPath('/login'),
  forgotPassword: appPath('/user/forgotpassword'),
  verifyverificationcode: appPath('/user/verifyverificationcode'),
  setpassword: appPath('/user/setpassword'),
}

export const _reportUrls = {
  getReport: appPath('/reportbyId'),
  getReportId:appPath("/fetchreportIdAccordingToStudyId"),
  deleteReport: appPath(`/discardreport`),
  rollbackReportDetail:appPath("/rollbackreport/detail"),
  updateReport: appPath("/updateReport"),
  notificationCount: appPath("/report/notificationcount"),
  saveProcessedReports: appPath("/report/saveProcessedReports"),
  previewReportDownload: appPath("/generateReport"),
}

export const _hospitalUrls = {
  add: appPath('/hospital/add'),
  list: appPath('/hospital/list'),
  update: appPath('/hospital/update'),
  delete: appPath('/hospital/delete'),
  getDetails: appPath('/hospital/detail'),
  odooApproved: appPath('/hospital/approveHospital'),
  addOnSelection: appPath('/hospital/updateHospitalAddOns'),
  checkCredit: appPath('/patient/creditCheck'),
}

// User Url
export const _userUrls = {
  add: appPath("/user/add"),
  delete: appPath("/user/delete"),
  activateUser: appPath("/user/activateUserStatus"),
  deactiveUser: appPath("/user/deactivatedUserList"),
  deactiveRadiologistUser: appPath("/user/deactivatedRadiologist"),
}

// Teleradiology User Url
export const _teleradiologyuserUrls = {
  add: appPath("/teraradiology/adduser"),
  delete: appPath('/teraradiology/delete'),
  changeReviewStatus: appPath('/changeReviewStatus'),
  deleteReviewStatus: appPath('/deleteReviewStatus'),
}

export const _commonUrls = {
  list: appPath("/common/data"),
  statecity: appPath("/common/statecity"),
  uploadImg: appPath("/common/uploadfile"),
  uploadMultipleImgs: appPath("/report/uploadMultipleImagesToS3"),
  getHospitalRadiologists: appPath("/user/fetchHospitalRadiologists"),
}
// Appointments Url
export const _appointmentUrls = {
  add: appPath('/appointment'),
  list: appPath('/appointment/list'),
  cancel: appPath('/appointment'),
  updateStaus: appPath('/appointment/status'),
  reschedule: appPath('/appointment/reschedule'),
  detail:appPath("/appointment/details"),
  detailByUID:appPath('/appointment/getAppointmentbyUID'),
  generatePDF: appPath('/appointment/generatePdf'),
  getAppointmentWithPatientId: appPath('/appointment/patientId'),
  getAIStudies: appPath('/appointment/getAIStudies')
}

export const _priceUrls = {
  add: appPath('/analytics/addOrUpdateModalityPrices'),
  edit: appPath('/analytics/updateReferringDoctor'),
  get: appPath('/analytics/getModalityPrices'),
  delete: appPath('/analytics/deleteModalityPrice'),
  addModalityStudy: appPath('/analytics/addModalityAndStudyRegion'),
  getModalityStudy: appPath('/analytics/getModalityAndStudyRegion'),
  getModifiedCreditHospitals: appPath('/settings/getTeleCreditHospitals'),
}

export const _redoScan = {
  patch: appPath('/appointment/updateApptStatusWithPatientId'),
  addReason: appPath('/report/updateRollbackReport'),
}

export const _patientUrls = {
  add: appPath('/patient'),
  list: appPath("/patient"),
  delete: appPath("/patient"),
  latestModality:appPath("/patient/searchlatestmobality"),
  prescriptionList:appPath("/patient/prescription"),
  prescriptionUpload:appPath("/patient/uploadprescription"),
  prescriptionDelete:appPath("/patient/deleteprescription"),
  healthcareUpdate: appPath("/patient/updatehealthcareinfo"),
  studiesList:dcemPath("/dcm4chee-arc/aets/DCM4CHEE/rs/studies"),
  activatePatient: appPath('/patient/activatePatient'),
  deactivatePatient: appPath('/patient/deactivatedPatientList'),
}

export const _billingUrls = {
  add: appPath('/billing-package/addBillingPackage'),
  get: appPath('/billing-package/getBillingPackages'),
  edit: appPath('/billing-package/updateBillingPackage'),
  delete: appPath('/billing-package/deleteBillingPackage'),
  addInvestigation: appPath('/billing-package/addInvestigationPackage'),
  getInvestigation: appPath('/billing-package/getInvestigationPackages'),
  editInvestigation: appPath('/billing-package/editInvestigationPackage'),
  deleteInvestigation: appPath('/billing-package/deleteInvestigationPackage')
}

// Modality questions
export const _modalityUrls = {
  list: appPath('/admin/masters/modality/question'),
}

export const _modalityQues = {
  get: appPath('/admin/masters/modality/question')
}

export const _attachementUrls = {
  add: appPath('/patient/attachments')
}

export const _auditUrls={
  list:appPath("/audit/list"),
  billingList:appPath("/billing-package/getBillingLogs"),
  teleradiologistList:appPath("/getTelepathologyLogs")
}
export const _pacsUrls = {
  add: appPath('/pacs/add'),
  edit: appPath(''),
  get:appPath('/pacs/list'),
  delete : appPath('/pacs/delete'),
  updateActivePACSDetail: appPath('/pacs/updateActivePacDetail')
}

export const _reportSettingsUrls = {
  get: appPath(`/hospital/detail`),
  edit: appPath('/hospital/hospitaltemplate')
}

export const _dashboardUrls = {
  get: appPath(`/dashboard/data`),
}

export const _machineUrls = {
  add: (deviceName) =>
    `${PACS_URL}/dcm4chee-arc/devices/${deviceName}`,
  get: `${PACS_URL}/dcm4chee-arc/aes`,
  delete: (deviceName) =>
    `${PACS_URL}/dcm4chee-arc/devices/${deviceName}`,
  edit: (deviceName) =>
    `${PACS_URL}/dcm4chee-arc/devices/${deviceName}`,
  getDevice: (deviceName) => `${PACS_URL}/dcm4chee-arc/devices/${deviceName}`
}

export const _PacsEditTagsUrls = {
  editStudyTags: (studyInstanceUID) =>
    `${PACS_URL}/dcm4chee-arc/aets/${AET}/rs/studies/${studyInstanceUID}`,

  editPatientTags: (patientID, patientIdentifier) =>
    `${PACS_URL}/dcm4chee-arc/aets/${AET}/rs/patients/${patientID}^^^${patientIdentifier}`,

  editSeriesTags: (studyInstanceUID, seriesInstanceUID) =>
    `${PACS_URL}/dcm4chee-arc/aets/${AET}/rs/studies/${studyInstanceUID}/series/${seriesInstanceUID}`,

  // editInstanceTags: (studyInstanceUID, seriesInstanceUID, sopInstanceUID) =>
  //   `${PACS_URL}/dcm4chee-arc/aets/DCM4CHEE/rs/studies/${studyInstanceUID}/series/${seriesInstanceUID}/instances/${sopInstanceUID}`
};

export const _radiologistUser = {
  get: appPath('/user/fetchradiologistuser'),
  assign: dcemPath(`/dcm4chee-arc/aets/DCM4CHEE/rs/studies`),
}

// Downloading Files from DCM4CHEE
export const _dcm4cheeUrls = (props:DCMurlParamsType)=> {
  console.log('_dcm4cheeUrls',props)
  if(props.downloadFormat == 'DCM'){
  if(props.studyInstanceUID != '' && props.seriesInstanceUID != '' && props.sopInstanceUID != ''){
    const downloadSop =  `${PACS_URL}/dcm4chee-arc/aets/${AET}/rs/studies/${props.studyInstanceUID}/series/${props.seriesInstanceUID}/instances/${props.sopInstanceUID}?accept=application/zip`
    return downloadSop
  }
  else if(props.studyInstanceUID != '' && props.seriesInstanceUID != '' && props.sopInstanceUID == ''){
    const downloadSeries = `${PACS_URL}/dcm4chee-arc/aets/${AET}/rs/studies/${props.studyInstanceUID}/series/${props.seriesInstanceUID}?accept=application/zip`
    return downloadSeries
  }
  else if(props.studyInstanceUID != '' && props.seriesInstanceUID == '' && props.sopInstanceUID == ''){
  const downloadStudy =`${PACS_URL}/dcm4chee-arc/aets/${AET}/rs/studies/${props.studyInstanceUID}?accept=application/zip`
  return downloadStudy
  }
  }
  else{
      const downloadSop =  `${PACS_URL}/dcm4chee-arc/aets/${AET}/wado?requestType=WADO&studyUID=${props.studyInstanceUID}&seriesUID=${props.seriesInstanceUID}&objectUID=${props.sopInstanceUID}`
      return downloadSop
  }
}

export const _deleteDicomUrl = (studyInstanceUID:string)=>{
  return dcemPath(`/dcm4chee-arc/aets/${AET}/rs/studies/${studyInstanceUID}/reject/113039%5EDCM`)
}

export const _studyDataUrls = {
  get:dcemPath(`/dcm4chee-arc/aets/${AET}/rs/studies?limit=500`),
  duplicate : (studyInstanceUID:string)=>{
    return dcemPath(`/dcm4chee-arc/aets/${AET}/rs/studies/${studyInstanceUID}/copy`)
  },
  mergeStudy: (targetUID:string,codeValue:string) =>{
    return dcemPath(`/dcm4chee-arc/aets/${AET}/rs/studies/${targetUID}/move/${codeValue}^${codingSchemeDesignator}`)
  }
}

export const _appointmentStudyUrls = {
  get: dcemPath(`/dcm4chee-arc/aets/DCM4CHEE/rs/studies?`),
}

export const _studyResearchUrls = {
  list: appPath('/studyresearch/list'),
  update: appPath('/studyresearch/updatedetail'),
  add: appPath('/studyresearch/add'),
}

export const _mediaServiceUrls = {
  createIso: appPath('/mediaservice/create-iso'),
  generateLink: appPath('/mediaservice/generatelink'),
  verifyStudyLink: appPath('/mediaservice/verifylink')
}

//Upload files to dcm4chee
export const _dcm4cheeUploadUrls = {
  upload: localDcemPath(`/dcm4chee-arc/aets/${AET}/rs/studies`),
}

// Billing
export const BILLING_ROUTES = {
  CONSULTATION_CHARGES: {
    get: appPath('/billing-package/getConsultationCharges'),
    add: appPath('/billing-package/addConsultationCharges'),
    edit: appPath('/billing-package/editConsultationCharges'),
    delete: appPath('/billing-package/deleteConsultationCharges'),
  },
  GENERAL_SETTINGS: {
    getCommon: appPath('/billing-package/getCommonGeneralSetting'),
    getGeneralSettings: appPath('/billing-package/getBillingGeneralSetting'),
    saveOrUpdate: appPath('/billing-package/saveOrUpdateGeneralSetting'),
  },
  URGENCY: {
    get: appPath('/urgency/getUrgency'),
    add: appPath('/urgency/addUrgency'),
    edit: appPath('/urgency/editUrgency'),
    delete: appPath('/urgency/deleteUrgency'),
  },
  INVOICE: {
    get: appPath('/getInvoices'),
    add: appPath('/generateInvoice'),
    getId: appPath('/getInvoiceById'),
    edit: appPath('/editInvoiceById'),
    download: appPath('/downloadInvoice'),
    refundLater: appPath('/invoice/changeRefundLaterStatus'),
  },
  DOCTOR_DISCOUNT: {
    get: appPath('/billing-package/referDoctor'),
    add: appPath('/billing-package/referDoctor'),
    edit: appPath('/billing-package/referDoctor'),
    delete: appPath('/billing-package/referDoctor'),
    invoiceDiscountRequest: appPath('/invoicesWithDiscountRequest'),
  },
  REPORTING_ANALYTICS: {
    get: appPath('/revenue-summary'),
  }
}

export const _teleModPriceUrls = {
  add: appPath('/settings/addTeleCredit'),
  get: appPath('/settings/getTeleCredit'),
  edit: appPath('/settings/editTeleCredit'),
  delete: appPath('/settings/deleteTeleCredit'),
  editHospital : appPath('/settings/updateHospitalTeleCredit'),
}

export const _teleServicePriceUrls = {
  add: appPath('/settings/addTeleServicePrice'),
  get: appPath('/settings/getTeleServicePrice'),
  edit: appPath('/settings/editTeleServicePrice'),
  delete: appPath('/settings/deleteTeleServicePrice'),
}

export const SUPERADMIN_URLS = {
  getSuperadminDetails: appPath('/user/getSuperadmin'),
  superadminDetails: appPath('/user/updateSuperadminInfo'),
  changePassword: appPath('/user/changeSuperadminPassword'),
}

export const _pricingUrls = {
  get: appPath('/hospital/getPlansFromOdoo'),
  update: appPath('/settings/addOrUpdatePlan'),
}

export const _addonUrls = {
  get: appPath('/settings/getAddons'),
  update: appPath('/settings/addOrUpdateAddons'),
}

export const _extraStorageUrls = {
  get: appPath('/settings/getExtraStoragePlans'),
  update: appPath('/settings/addOrUpdateExtraStorage'),
}

export const _creditForCaseToCase = {
  get: appPath('/hospital/getCaseCredits'),
  post: appPath('/hospital/addCaseCredits'),
  update: appPath('/hospital/updateCaseCredit'),
  delete: appPath('/hospital/deleteCaseCredit'),
  editHospital : appPath('/settings/updateHospitalCaseCredits'),
  getHospital: appPath('/settings/getHospitalCaseCredits'),
  getCaseToCaseHospital: appPath('/settings/getCase2CaseHospitals'),
}

export const _stripe_gateway = {
  createPortalSession : appPath('/payement/create-checkout-session'),
  deductCredits : appPath('/payement/deductCredits')
}

export const _creditsPerGb = {
  getCreditPerGb : appPath('/hospital/getCreditPerGB'),
  addUpdateCreditPerGb : appPath('/hospital/addOrUpdateCreditPerGB')
}

export const _discountUrls = {
  request: appPath('/requestDiscount'),
  getRequests: appPath('/invoicesWithDiscountRequest'),
  chnageStatus: appPath('/approveDiscount'),
}

export const _switchUserRole = {
  switchRole: appPath('/user/changeUserRole'),
}

export const _moveExtra = {
  moveToExtraStorage : appPath('/extraStorage/transferStudyToExtraStorage'),
  switchPathologyStudyStorage : appPath('/microscopy/transferMicroscopyLink')
}

export const SUBSCRIPTION_URL = {
  getSubscribedStudies: appPath('/subscription/getSubscribedStudies'),
  getSubscribedStatus: appPath('/subscription/getSubscribedStatus'),
  sendPlanDetails: appPath('/hospital/sendPlanDetails'),
}

export const _speechToTextUsers = {
  getSpeechToTextUsers: appPath('/hospital/checkSpeechToTextUser'),
}


export const _giftCardUrls = {
  get: appPath('/hospital/fetchGiftCards'),
}

export const _aiServiceUrls = {
  CTBrian: aiPath('/predict-hemorrhage'),
  XRAYBone: aiPath('/predict-fracture'),
}
